import { handleActions } from 'redux-actions'

const defaultHistoryState = []

export const history = handleActions({
  GET_ORDERS: (state, action) => {
    // history state check before order
    return action.payload
  },
}, defaultHistoryState)

export default {
  history,
}



// WEBPACK FOOTER //
// ./src/reducers/components/history.js